import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import AuthActions from 'store/redux/auth'

import { pageData } from 'decorators'
import { ImageAndText, Button, FG } from 'components'
import { Form } from 'reactstrap'

import { translate } from 'react-i18next'
import GameTemplate from '../templates/GameTemplate'

import './Presets.css'

@pageData({ title: 'Presets' })
@connect(
    state => ({
        isLoading: state.global.loading,
    }),
    {
        setNickname: AuthActions.setNickname
    }
)
@translate()
@reduxForm({ form: 'nickData' })
export class Presets extends PureComponent {
    onSubmit = ({ nickname }) => this.props.setNickname(nickname)
    render() {
        const { isLoading, handleSubmit, invalid, submitting, t } = this.props

        return (
            <GameTemplate className="Presets darkmode-background">
                <div className="Presets-wrapper">
                    <ImageAndText image={{ src: '/assets/helmet.svg', style: { width: '100%', height: '140px' } }} text={t('presets.form.title')} className="Presets-content" />

                    <Form onSubmit={handleSubmit(this.onSubmit)} className="flex col-center" autoComplete="off">
                        <FG.Text id="nickname" name="nickname" type="text" className="Presets-field" label={t('presets.form.placeholder')} required autoComplete="off" />
                        <Button type="submit" color="primary" loading={isLoading} disabled={invalid || submitting}>
                            {t('presets.form.button')}
                        </Button>
                    </Form>
                </div>
            </GameTemplate>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Presets/Presets.js